var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert fade-in show",class:`alert-${_vm.notification.type}`,attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.notification.message)+" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])
}]

export { render, staticRenderFns }